// extracted by mini-css-extract-plugin
export default {"footerBg":"P-z","footerTopLinks":"Q-z","footerFeedback":"R-z","footerSocial":"S-z","footerLegalLinks":"T-z","footerIconCards":"U-z","footerBotCopy":"V-z"};